import { useState } from "react";
import Translatable from "../translatable_text/Translatable"
import { Conditional } from "../conditional-render/ConditionalRender";

type Props = {
  service: any
}
export default function ServiceCard({service}: Props) {

  const [isVideoReady, setIsVideoReady] = useState(false);
  const [hasError, setHasError] = useState(false);


  return (
    <div className="mb-10 rotate-text">
      <div className="service-item">
        {/* Placeholder (shown until video is ready or if error) */}
        {(!isVideoReady || hasError) && (
          <img
            src={service?.images?.[1] || "/light/assets/imgs/fallback.png"}
            alt="placeholder"
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover rounded-md"
          />
        )}
        <Conditional condition={!hasError}>
          <video
            width="100%"
            preload="metadata"
            autoPlay
            playsInline
            muted
            loop
            className={`${!isVideoReady ? 'opacity-0' : 'opacity-100'} transition-opacity duration-500`}
            onLoadedData={() => setIsVideoReady(true)}
            onError={() => setHasError(true)}
          >
            <source src={service?.vid} type="video/mp4" />
          </video>
        </Conditional>
        
        <div className="flex service-dsec items-center mt-4">
          <div>
            <div className="icon">
              <img src={service?.img} alt="img" loading="lazy"/>
            </div>
          </div>
          <div className="ml-4x flex flex-col items-center">
            <span>{service?.title}</span>
            <div className="flex justify-center text mt-3">
              <span className="item-box-desc mb-5"><Translatable>{service?.desc}</Translatable></span>
            </div>
            <a className='flex md:underline transition-colors duration-200' href={`${service?.link}/${service.id}`}>
              <span><Translatable>Explore the product</Translatable></span>
              <div className='hidden md:block'>
                <span className="ti-arrow-top-right mx-3"></span>
              </div>
              <img 
                src="/light/assets/imgs/arrow-right.webp"
                alt="icon"
                className="md:hidden icon-img-20 ml-10 mr-10"
                loading="lazy"
                width="40px"
                height="40px"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
